//documentation here https://sendgrid.com/docs/API_Reference/api_v3.html

(function() {

	$( document ).ready( function() {

		var form = $( '.form-newsletter-form' );

		$('form.contact-form').submit( function( e ){

			e.preventDefault();

			if( $( $( e )[ 0 ].currentTarget ).hasClass( 'unsubmitted' ) ) {

				e.preventDefault();

			}

			$( 'p.error, p.success' ).remove();

			if( $( this ).find( 'input[type="email"]' ).val() !== '') {

			var data = $( this ).serialize();
			$.ajax({
				type: "POST",
				url: "/contact",
				data: data,
				success: function() {

					e.preventDefault();

					$( '#form-newsletter-first-name' ).val( '' );
					$( '#form-newsletter-last-name' ).val( '' );
					$( '#form-newsletter-email' ).val( '' );

					$( '.input-group', form ).css( "display", "none" );
					$( '.form-newsletter-submit' ).css( "display", "none" );
					$( '.form-newsletter-title' ).text( window.theme.newsletter.welcome );
					$( '.form-newsletter-initial-message' ).css( "display", "none" );

					if( window.theme.newsletter && window.theme.newsletter.discount && window.theme.newsletter.message ) {

						$( '.form-newsletter-message' ).append( '<p>' + window.theme.newsletter.message + ' <strong>'+ window.theme.newsletter.discount +'</strong></p>' );

					}else if( window.theme.newsletter && window.theme.newsletter.message ){

						$( '.form-newsletter-message' ).append( '<p>' + window.theme.newsletter.message +'</p>' );

					} else {

						$( '.form-newsletter-message' ).append( '<p>' + window.theme.newsletter.thankYou + '</p>' );

					}

				},
				error: function( responseerror ) {

					e.preventDefault();


					$( '.form-newsletter-submit-button' ).css('background-color', '#D13239');
					$( '.form-newsletter-submit-button' ).css('color', '#ffffff');
					$( '.form-newsletter-submit-button').html('<span>'+ window.theme.newsletter.subscribe +'</span>');

					$( '.form-newsletter-message' ).html( '<p class="text-blue">' + window.theme.newsletter.error +'</p>' );

				}
			});

			}

		});

		$( '#newsletter-signup-account-checkbox' ).click( function( e ) {

			$( '#newsletter-signup-account' ).submit();

		});

	});

})();
